export const distributorsPageTranslationsPl = {
    distributorsPage: 'Dystrybutorzy',
    distributorEmail: 'Adres e-mail',
    distributorName: 'Nazwa dystrybutora',
    distributorNotes: 'Uwagi',
    distributorAddDistributor: 'Dodaj nowego dystrybutora',
    distributorRemoveConfirmationMessage: 'Czy na pewno chcesz usunąć wybranego dystrybutora?',
    distributorDelete: 'Usuń dystrybutora',
    distributorUpdate: 'Edytuj dystrybutora',
    distributorsConflictedEmail: 'Podany adres e-mail już istnieje',
};
export const distributorsPageTranslationsEn = {
    distributorsPage: 'Distributors',
    distributorEmail: 'E-mail',
    distributorName: 'Distributor name',
    distributorNotes: 'Remarks',
    distributorAddDistributor: 'Add new distributor',
    distributorRemoveConfirmationMessage: 'Are you sure you want to delete the selected distributor?',
    distributorDelete: 'Remove distributor',
    distributorUpdate: 'Update distributor',
    distributorsConflictedEmail: 'Given e-mail address is already defined',
};
